import {
  ComponentType,
  CSSProperties,
  ReactElement,
  MouseEvent as ReactMouseEvent,
  SVGProps
} from 'react';
import styled, { keyframes } from 'styled-components';

const hideShow = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
`;

const Span = styled.span`
  line-height: 0;
  display: inline-block;
  text-align: center;

  &&.ft-icon--loading {
    animation: ${hideShow} 1s ease-in-out infinite;
  }
`;

type WithIconProps = {
  className?: string;
  style?: CSSProperties;
  onClick?: (event: ReactMouseEvent<HTMLSpanElement, MouseEvent>) => void;
  title?: string;
  loading?: boolean;
  size?: number;
};

export function withIcon(
  Child: ComponentType<SVGProps<SVGSVGElement | { className: string }>>
) {
  return (props: WithIconProps): ReactElement => {
    return (
      <Span
        {...props}
        className={`ft-icon ${props?.className || ''} ${
          props?.loading ? 'ft-icon--loading' : ''
        }`}
        style={props?.size ? { fontSize: props?.size + 'px' } : {}}
      >
        <Child width="1em" height="1em" fill="currentColor" />
      </Span>
    );
  };
}
